import { marked } from "marked"

const ALLOWED_LINK_SCHEMES = ["http", "https", "mailto", "tel"]

const BASIC_ENTITIES = { amp: "&", lt: "<", gt: ">", quot: "\"", apos: "'" }

function escapeAttr(value) {
  return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
}

// AI przepisuje adresy z HTML-a artykułów ("?a=1&amp;b=2"), więc dekodujemy encje liczbowe i podstawowe
// (jednym przebiegiem). Pozostałe zostają i po escapowaniu są dla przeglądarki zwykłym tekstem.
function decodeEntities(value) {
  return value.replace(/&(?:#(\d+)|#[xX]([0-9a-fA-F]+)|(amp|lt|gt|quot|apos));/g, (entity, dec, hex, name) => {
    if (name) return BASIC_ENTITIES[name]

    const codePoint = dec ? parseInt(dec, 10) : parseInt(hex, 16)
    if (codePoint > 0x10ffff) return entity

    return String.fromCodePoint(codePoint)
  })
}

// Adres bez schematu (względny) przepuszczamy. Białe i sterujące znaki ("java\tscript:") koduje encodeURI,
// a zakodowanych przeglądarka nie wycina przed odczytem schematu - taki adres zostaje względny.
function safeLinkUrl(rawHref) {
  const href = decodeEntities(rawHref)
  let url
  try {
    url = encodeURI(href).replace(/%25/g, "%")
  } catch {
    return null
  }

  const scheme = href.match(/^([a-z][a-z0-9+.-]*):/i)
  if (scheme && !ALLOWED_LINK_SCHEMES.includes(scheme[1].toLowerCase())) return null

  return url
}

// Linki otwierają się w nowym oknie. Link z niedozwolonym schematem (javascript:, data:) zostaje samym tekstem.
// href escapujemy sami: marked przepuszcza encje ("javascript&#58;"), które przeglądarka by zdekodowała.
const renderer = new marked.Renderer()
renderer.link = function ({ href, title, tokens }) {
  const text = this.parser.parseInline(tokens)
  const url = safeLinkUrl(href)
  if (url == null) return text

  const titleAttr = title ? ` title="${escapeAttr(title)}"` : ""
  return `<a target="_blank" rel="noopener" href="${escapeAttr(url)}"${titleAttr}>${text}</a>`
}

marked.setOptions({ renderer, breaks: true, gfm: true })

// Konwersja markdown → HTML (marked + target=_blank na linkach)
// Escapuje surowy HTML w inputcie (zapobieganie XSS) przed parsowaniem markdown
export function simpleMarkdownToHtml(text) {
  if (!text) return ""
  const escaped = text.replace(/</g, "&lt;").replace(/>/g, "&gt;")
  return marked.parse(escaped)
}
